import { CountryCode, parsePhoneNumberWithError } from 'libphonenumber-js';

export interface ParsedPhoneNumber {
  countryCode: string;
  phoneWithoutCountryCode: string;
  isValid: boolean;
}

/**
 * Parses a phone number to extract country code and national number.
 * Falls back to removing non-digit characters if parsing fails.
 *
 * @param phone - The phone number to parse
 * @param defaultAlpha2CountryCode - The ISO alpha-2 country code (e.g., 'BR')
 * @returns An object containing the country code (without +), the phone number without country code and if the phone number is valid
 */
export const parsePhoneNumber = (
  phone: string | undefined | null,
  defaultAlpha2CountryCode?: string | null,
): ParsedPhoneNumber => {
  let countryCode = '55';
  let phoneWithoutCountryCode = phone || '';
  let isValid = false;

  if (phone) {
    const regexNonDigits = /[^0-9]/g;

    try {
      const parsed = parsePhoneNumberWithError(phone, defaultAlpha2CountryCode as CountryCode);

      if (parsed && parsed.isValid()) {
        countryCode = parsed.countryCallingCode || countryCode;
        phoneWithoutCountryCode = parsed.nationalNumber || phone;
        isValid = true;
      } else {
        // If parsing succeeds but number is invalid, fallback to removing non-digits
        phoneWithoutCountryCode = phoneWithoutCountryCode.replace(regexNonDigits, '');
      }
    } catch (error) {
      console.warn('Failed to parse phone number:', phone, error);
      phoneWithoutCountryCode = phoneWithoutCountryCode.replace(regexNonDigits, '');
    }
  }

  return {
    countryCode,
    phoneWithoutCountryCode,
    isValid,
  };
};
